<template>
  <div id="content">
    <h1>新手生存指南</h1>
    <p style="margin-left: 15%;"><img src="https://i.loli.net/2019/11/24/bsO5WDuaBonL7Uv.jpg" alt="steem" id="newbie"></p>
    <div class="newtext">
    <router-link to="/searcharticle/@lemooljiang/3f5j36-steem" target="_blank">1、steem介绍</router-link>
    <br>
    <router-link to="/searcharticle/@lemooljiang/4xxuhj" target="_blank">2、翻墙注册（更新版）</router-link>
    <br>
    <router-link to="/searcharticle/@lemooljiang/4kkmhd" target="_blank">3、发贴赚钱</router-link>
    <br>
      <router-link to="/searcharticle/@lemooljiang/4mddsq" target="_blank">4、图文编辑三板斧（更新版）</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/3xqvw9" target="_blank">5、工具红宝书</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/supload" target="_blank">6、新图床supload，顺便赚点比特币</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/p" target="_blank">7、P图神技</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/3xem6o" target="_blank">8、快速查询及归类</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/3s29oy" target="_blank">9、勤于打扫，与垃圾号绝交</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/6hgzux" target="_blank">10、一分钟注册新帐户（需要付费）</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/markdown-steemit" target="_blank">11、Markdown语法规范</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/4rxtdx" target="_blank">12、好玩的表情包和字体图标</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/km1n4" target="_blank">13、极速提现</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/6jrje-steemit" target="_blank">14、steemit上的长跑</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/2dfqrq" target="_blank">15、密码即一切</router-link>
      <br>
      <router-link to="/searcharticle/@lemooljiang/steem-dapp" target="_blank">16、基于steem的应用DAPP</router-link>
      <br>
    </div>

  </div>
</template>

<script>

  export default {
    name: "Newbie",
    data() {
      return {

      }
    },

    mounted() {


    },

  }
</script>

<style scoped>
  h1{
    font-size: 2rem;
    padding-left: 30%;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ddd;
  }
  #content{
    color: rgba(55,53,58,0.75);
    align: center;
    margin: 1rem auto;
    width: 75%;
    padding-bottom: 0.2rem;
  }
  #newbie{
    width: 45%;

  }
 .newtext{
   margin-left: 20%;
   margin-top: -3rem;
   font-size: 1.1rem;
 }

  a{
    color: rgba(55,53,58,0.75);
  }

  a:hover{
    color: darkcyan;
    text-decoration: none;

  }

  .btn-outline-primary {
    color: rgba(55,53,58,0.75);
    border-color: rgba(55,53,58,0.75);
  }
  .btn-outline-primary:hover{
    background-color: chocolate;
  }
</style>

